/* Package JSON Import will be here */
import React from "react";
import { Route } from "react-router-dom";
/* Package JSON Import will be here */

/* Project Import will be here */
import PublicRoutesAuthWrapper from "app/authWrapper/PublicRoutesAuthWrapper";
import Index from "pages/Index";
import IvyRouterContainer from "containers/common/IvyRouterContainer";
/* Project Import will be here */

const AppRoutes = () => (
  <main>
    <Route exact path="/" component={PublicRoutesAuthWrapper(Index)} />
    <Route path="/ivy" component={IvyRouterContainer} />
  </main>
);

export default AppRoutes;